import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import HeaderWithBack from '../Components/HeaderWithBack';
import Loading from '../Components/Loading';

import styles from '../Styles/Account.module.css';
import stylesIndex from '../Styles/Index.module.css';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

const Fields = () => {
    const navigate = useNavigate();
    const { openTimeModal } = useTimeModal();

    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    const [formInfo, setFormInfo] = React.useState({
        id: '',
    });

    React.useEffect(() => {
        axios.get('/api/get-fields')
        .then((response) => {
            setFormInfo(response.data);
        }).catch(error => {
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoading(false);
        });
    }, []);

    const changeFields = () => {
        axios.put("/api/change-fields", {
            company_name: formInfo.company_name,
            phone_number: formInfo.phone_number,
            phone_number_additional: formInfo.phone_number_additional,
            address: formInfo.address,
            mainh2: formInfo.mainh2,
            h2: formInfo.h2,
            firsth3: formInfo.firsth3,
            secondh3: formInfo.secondh3,
            thirdh3: formInfo.thirdh3,
            firsttextarea: formInfo.firsttextarea,
            secondtextarea: formInfo.secondtextarea,
            thirdtextarea: formInfo.thirdtextarea,
        })
        .then((res) => {
            openTimeModal('Данные изменены', 'success');
        })
        .catch((error) => {
            console.error("Ошибка:", error);
            openTimeModal(`${error.message}`, 'error');
        });
    };

  return (
    <div className='main'>
        <HeaderWithBack />
        {/* <div> */}
            <div className={styles.boxPanel} style={{margin: '5px 0'}}>
            <h3>Основные поля</h3>
            {loading ? <Loading />
            : warning ? <p className='description'>{warning}</p>
            :
            <>
            <div className={stylesIndex.panel}>
                <a>Название компании</a>
                <input 
                    type='text' 
                    style={{textAlign: 'start'}} 
                    value={formInfo.company_name}
                    onChange={(e) =>
                        setFormInfo({
                        ...formInfo,
                        company_name: e.target.value,
                        })
                    } 
                />
                <a>Текст под названием компании на главной странице</a>
                <input 
                    type='text' 
                    style={{textAlign: 'start'}} 
                    value={formInfo.mainh2}
                    onChange={(e) =>
                        setFormInfo({
                        ...formInfo,
                        mainh2: e.target.value,
                        })
                    } 
                />
                <a>Номер телефона</a>
                <input 
                    type='text' 
                    style={{textAlign: 'start'}} 
                    value={formInfo.phone_number}
                    onChange={(e) =>
                        setFormInfo({
                        ...formInfo,
                        phone_number: e.target.value,
                        })
                    } 
                />
                <a>Дополнительный номер телефона</a>
                <input 
                    type='text' 
                    style={{textAlign: 'start'}} 
                    value={formInfo.phone_number_additional}
                    onChange={(e) =>
                        setFormInfo({
                        ...formInfo,
                        phone_number_additional: e.target.value,
                        })
                    } 
                />
                <a>Адрес</a>
                <input 
                    type='text' 
                    style={{textAlign: 'start'}} 
                    value={formInfo.address}
                    onChange={(e) =>
                        setFormInfo({
                        ...formInfo,
                        address: e.target.value,
                        })
                    } 
                />
            </div>
            <div className={stylesIndex.panel}>
                <h2>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="#6563FF" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>
                    <input 
                        type='text' 
                        style={{textAlign: 'start'}} 
                        value={formInfo.h2}
                        onChange={(e) =>
                            setFormInfo({
                            ...formInfo,
                            h2: e.target.value,
                            })
                        } 
                    />
                </h2>

                <h3>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="corner-down-right"><path fill="#0a9f3c" d="M19.61,16a1.19,1.19,0,0,0-.22-.33L14.76,11a1,1,0,0,0-1.41,1.41l2.92,2.92h-7a3,3,0,0,1-3-3V3a1,1,0,1,0-2,0v9.37a5,5,0,0,0,5,5h7l-2.92,2.92a1,1,0,0,0,0,1.42,1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l4.63-4.63a1,1,0,0,0,.22-.33A1,1,0,0,0,19.61,16Z"></path></svg>
                    <input 
                        type='text' 
                        style={{textAlign: 'start'}} 
                        value={formInfo.firsth3}
                        onChange={(e) =>
                            setFormInfo({
                            ...formInfo,
                            firsth3: e.target.value,
                            })
                        } 
                    />
                </h3>
                <p>
                    <a>Введите описание (поддерживается форматирование):<br/></a>
                    <a className='description'>Например, знак "-" создает элемент списка.</a>
                    <textarea
                        placeholder="Введите текст"
                        rows="5"
                        maxLength={1000}
                        value={formInfo.firsttextarea}
                        onChange={(e) =>
                            setFormInfo({
                            ...formInfo,
                            firsttextarea: e.target.value,
                            })
                        }
                        required
                    />
                    <a>Предпросмотр описания:</a>
                    <div className='markdownContainer' style={{border: '1px solid #e5e5e5', borderRadius: '4px', padding: '10px', marginBottom: '20px'}}>
                        <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                            p: ({node, ...props}) => <p style={{whiteSpace: 'pre-wrap'}} {...props} />
                        }}
                        breaks
                        >
                        {formInfo.firsttextarea}
                        </ReactMarkdown>
                    </div>
                </p>

                <h3>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="corner-down-right"><path fill="#6563FF" d="M19.61,16a1.19,1.19,0,0,0-.22-.33L14.76,11a1,1,0,0,0-1.41,1.41l2.92,2.92h-7a3,3,0,0,1-3-3V3a1,1,0,1,0-2,0v9.37a5,5,0,0,0,5,5h7l-2.92,2.92a1,1,0,0,0,0,1.42,1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l4.63-4.63a1,1,0,0,0,.22-.33A1,1,0,0,0,19.61,16Z"></path></svg>
                    <input 
                        type='text' 
                        style={{textAlign: 'start'}} 
                        value={formInfo.secondh3}
                        onChange={(e) =>
                            setFormInfo({
                            ...formInfo,
                            secondh3: e.target.value,
                            })
                        } 
                    />
                </h3>
                <p>
                    <a>Введите описание (поддерживается форматирование):<br/></a>
                    <a className='description'>Например, знак "-" создает элемент списка.</a>
                    <textarea
                        placeholder="Введите текст"
                        rows="5"
                        maxLength={1000}
                        value={formInfo.secondtextarea}
                        onChange={(e) =>
                            setFormInfo({
                            ...formInfo,
                            secondtextarea: e.target.value,
                            })
                        }
                        required
                    />
                    <a>Предпросмотр описания:</a>
                    <div className='markdownContainer' style={{border: '1px solid #e5e5e5', borderRadius: '4px', padding: '10px', marginBottom: '20px'}}>
                        <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                            p: ({node, ...props}) => <p style={{whiteSpace: 'pre-wrap'}} {...props} />
                        }}
                        breaks
                        >
                        {formInfo.secondtextarea}
                        </ReactMarkdown>
                    </div>
                </p>

                <h3>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="corner-down-right"><path fill="#45118a" d="M19.61,16a1.19,1.19,0,0,0-.22-.33L14.76,11a1,1,0,0,0-1.41,1.41l2.92,2.92h-7a3,3,0,0,1-3-3V3a1,1,0,1,0-2,0v9.37a5,5,0,0,0,5,5h7l-2.92,2.92a1,1,0,0,0,0,1.42,1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l4.63-4.63a1,1,0,0,0,.22-.33A1,1,0,0,0,19.61,16Z"></path></svg>
                    <input 
                        type='text' 
                        style={{textAlign: 'start'}} 
                        value={formInfo.thirdh3}
                        onChange={(e) =>
                            setFormInfo({
                            ...formInfo,
                            thirdh3: e.target.value,
                            })
                        } 
                    />
                </h3>
                <p>
                    <a>Введите описание (поддерживается форматирование):<br/></a>
                    <a className='description'>Например, знак "-" создает элемент списка.</a>
                    <textarea
                        placeholder="Введите текст"
                        rows="5"
                        maxLength={1000}
                        value={formInfo.thirdtextarea}
                        onChange={(e) =>
                            setFormInfo({
                            ...formInfo,
                            thirdtextarea: e.target.value,
                            })
                        }
                        required
                    />

            
                    <a>Предпросмотр описания:</a>
                    <div className='markdownContainer' style={{border: '1px solid #e5e5e5', borderRadius: '4px', padding: '10px', marginBottom: '20px'}}>
                        <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                            p: ({node, ...props}) => <p style={{whiteSpace: 'pre-wrap'}} {...props} />
                        }}
                        breaks
                        >
                        {formInfo.thirdtextarea}
                        </ReactMarkdown>
                    </div>
                </p>
                <div style={{position: 'sticky', bottom: '0px', backgroundColor: '#ffffff', padding: '10px 0', boxSizing: 'border-box'}}>
                    <button type='button' className='button' onClick={() => changeFields()}>Сохранить изменения</button>
                </div>
            </div>
          </>}
        </div>
      {/* </div> */}
    </div>
  )
}

export default Fields;